/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { lazyLoadComponent } from '~shared/helpers/lazyLoadComponent';

export const ArchitectureAdminBanner = lazyLoadComponent(() => import('./ArchitectureAdminBanner'));
export const ArchitectureUserBanner = lazyLoadComponent(() => import('./ArchitectureUserBanner'));
